import {useNavigate} from "react-router-dom";
import {useAtom, useSetAtom} from "jotai";
import {tokenResultAtom} from "../login/entity";
import {modalController} from "../../store";
import {AdminInfo} from "../layout";
import {
  accountCreateInvoice,
  accountInfoColumns,
  accountInfoRevenue,
  accountInfoSetting,
  accountInfoTable,
  accountProfile,
  refundRequestData
} from "./entity";
import React, {useCallback, useEffect, useRef, useState} from "react";
import styled from "styled-components";
import Select from "react-select";
import {
  accountCreateInvoiceRecord,
  accountMonthlyListTableData,
  accountRevenueStatus,
  accountUserProfile
} from "../../services/account/AccountAdminAxios";
import {
  userAccountMonthlyListTableData,
  userAccountProfile,
  userAccountRevenueStatus
} from "../../services/account/AccountUserAxios";
import {toast, ToastContainer} from "react-toastify";
import {BoardSearchResult, CustomDatePicker} from "../../assets/GlobalStyles";
import {decimalFormat, removeStr} from "../../common/StringUtils";
import Table from "../../components/table";
import HorizontalScrollGuide from "../../components/table/HorizontalScrollGuide";
import {useForm} from "react-hook-form";
import {ModalBody, ModalHeader} from "../../components/modal/Modal";
import {
  lockedRows,
  summaryReducer
} from "../reports/entity/common";
import {getThisMonth} from "../../common/DateUtils";
import {selKeywordUser} from "../../services/platform/ManageUserAxios";
import ko from "date-fns/locale/ko";

const accountSelectStyle = {
  container:styles=>({...styles,minWidth:130,flex:1}),
  control:styles=>({...styles,minHeight:36,height:36,border:0,
    borderRadius:0,boxShadow:"none",background:"transparent",fontSize:13,
    ":hover":{border:0}}),
  valueContainer:styles=>({...styles,height:38,padding:"0 11px"}),
  indicatorsContainer:styles=>({...styles,height:38}),
  indicatorSeparator:()=>({display:"none"}),
  singleValue:styles=>({...styles,color:"#1d5fae",fontWeight:750}),
  menu:styles=>({...styles,zIndex:50,border:"1px solid var(--color-border-strong)",borderRadius:7,overflow:"hidden"}),
  option:(styles,state)=>({...styles,padding:"9px 11px",fontSize:13,
    background:state.isSelected?"var(--color-primary-soft)":state.isFocused?"#f7fbff":"var(--color-surface)",
    color:state.isSelected?"var(--color-primary-strong)":"#4b5563",fontWeight:state.isSelected?750:500,
    boxShadow:state.isSelected?"inset 3px 0 0 var(--color-primary-strong)":"none"}),
};

function MonthRangePicker({value,setValue}) {
  const parseMonth = month => month ? new Date(`${month}-01T00:00:00`) : null
  const formatMonth = date => {
    const year = date.getFullYear()
    const month = String(date.getMonth()+1).padStart(2,"0")
    return `${year}-${month}`
  }
  const startDate = parseMonth(value.searchStartDate)
  const endDate = parseMonth(value.searchEndDate)
  const changeStart = date => {
    const nextStart = formatMonth(date)
    setValue(prev => ({
      ...prev,
      searchStartDate:nextStart,
      searchEndDate:prev.searchEndDate < nextStart ? nextStart : prev.searchEndDate,
    }))
  }
  const changeEnd = date => setValue(prev => ({...prev,searchEndDate:formatMonth(date)}))
  return <MonthPickerRow>
    <MonthPickerBox><CustomDatePicker selected={startDate} onChange={changeStart}
      selectsStart startDate={startDate} endDate={endDate} maxDate={new Date()}
      dateFormat="yyyy.MM" locale={ko} showMonthYearPicker
      portalId="account-datepicker-portal"/></MonthPickerBox>
    <MonthRangeSeparator>~</MonthRangeSeparator>
    <MonthPickerBox><CustomDatePicker selected={endDate} onChange={changeEnd}
      selectsEnd startDate={startDate} endDate={endDate} minDate={startDate} maxDate={new Date()}
      dateFormat="yyyy.MM" locale={ko} showMonthYearPicker
      portalId="account-datepicker-portal"/></MonthPickerBox>
  </MonthPickerRow>
}

function ModalRequestAmount (props){
  const [,setModal] = useAtom(modalController)
  const {tax, maxAmount} = props
  const [requestAmountValue, setRequestAmountValue] = useState(0)
  const [requestAmountVAT, setRequestAmountVAT] = useState(0)
  const [examinedAmount, setExaminedAmount] = useState(0)

  const {register, handleSubmit, setValue, setError, formState:{errors} } = useForm()

  useEffect(() => {
    setRequestAmountVAT(tax !== 'Y' ? 0 : requestAmountValue / 10);
  }, [tax, requestAmountValue]);

  const cancelBtn = () => {
    setModal({
      isShow: false
    })
  }
  const handleChange = (value) => {
    let num = removeStr(value);
    let numberNum = Number(num);
    if((numberNum !== 0 && maxAmount === undefined) || (maxAmount < numberNum)){
      setError('requestAmountValue', {type: 'required', message:'정산 신청금이 잔여 정산금을 초과하였습니다.'})
      setRequestAmountValue(numberNum)
    } else {
      setRequestAmountValue(numberNum)
      setValue('requestAmountValue', numberNum)
      tax !== 'Y' ? setRequestAmountVAT(0) : setRequestAmountVAT(numberNum / 10)
      tax !== 'Y' ? setExaminedAmount(numberNum) : setExaminedAmount(numberNum+(numberNum/10))
      setError('requestAmountValue', '')
    }
  }

  const handleAllChange = (value) => {
    let num = removeStr(value);
    let numberNum = Number(num);
    if(maxAmount !== undefined){
        setRequestAmountValue(numberNum)
        setValue('requestAmountValue', numberNum)
        tax !== 'Y' ? setRequestAmountVAT(0) : setRequestAmountVAT(numberNum / 10)
        tax !== 'Y' ? setExaminedAmount(numberNum) : setExaminedAmount(numberNum+(numberNum/10))
        setError('requestAmountValue', '')
    } else {
      setRequestAmountValue(0)
      setError('requestAmountValue', '')
      toast.warning("정산 가능 금액이 없습니다.");
    }
  }
  const onSubmit = () => {
    if (maxAmount === undefined || maxAmount <= 0) {
      toast.warning("정산 가능 금액을 확인해주세요.");
      return;
    }

    if (requestAmountValue < 100000) {
      setError('requestAmountValue', {
        type: 'required',
        message: '정산 신청금은 최소 10만원 이상 설정 가능합니다.',
      });
      return;
    }

    if (requestAmountValue > maxAmount) {
      setError('requestAmountValue', {
        type: 'required',
        message: '정산 신청금이 잔여 정산금을 초과하였습니다.',
      });
      return;
    }

    props.handleOnSubmit(requestAmountValue);
  };
  const onError = () => console.log(errors)

  return (
    <SettlementForm onSubmit={handleSubmit(onSubmit, onError)}>
      <ModalHeader variant="search" title={'정산 신청'}/>
      <ModalBody>
        <SettlementModalBody>
          <SettlementNotice>
            <NoticeIcon>i</NoticeIcon>
            <div><strong>정산 신청 안내</strong>
              <p>최종 결산은 매월 5일까지의 통계를 기준으로 집계되며, 승인 후 매월 10일 이전까지 세금계산서를 발행해주세요.</p>
              <p>신청하지 않은 수익금은 다음 달로 자동 이월됩니다.</p>
            </div>
          </SettlementNotice>
          <AvailableAmount>
            <span>정산 가능 금액</span>
            <strong>{decimalFormat(maxAmount)}<em>원</em></strong>
          </AvailableAmount>
          <AmountSection>
            <AmountLabel><div><strong>정산 신청금</strong><span>최소 100,000원부터 신청할 수 있습니다.</span></div></AmountLabel>
            <AmountInputRow>
              <AmountInputWrap>
                <input type={'text'} value={decimalFormat(requestAmountValue)}
                           {...register("requestAmountValue", {
                             required: "정산 금액을 입력해주세요,",
                             pattern:{
                               value: /^[0-9,]+$/,
                               message: "숫자만 입력 가능합니다."
                             },
                             onChange:(e) => handleChange(e.target.value)
                           })}
                  />
                <span>원</span>
              </AmountInputWrap>
              <AllAmountButton type='button' onClick={() => handleAllChange(maxAmount)}>전액 신청</AllAmountButton>
            </AmountInputRow>
            {errors.requestAmountValue && <AmountError>{errors.requestAmountValue.message}</AmountError>}
          </AmountSection>
          <PaymentSummary>
            <SummaryRow><span>신청 금액</span><strong>{decimalFormat(requestAmountValue)}원</strong></SummaryRow>
            <SummaryRow><span>VAT</span><strong>{decimalFormat(requestAmountVAT)}원</strong></SummaryRow>
            <SummaryDivider/>
            <SummaryRow $total><span>지급 예정 금액</span><strong>{requestAmountValue === 0 ? '0' : decimalFormat(examinedAmount)}원</strong></SummaryRow>
          </PaymentSummary>
        </SettlementModalBody>
      </ModalBody>
      <SettlementFooter>
        <ModalCancelButton type='button' onClick={()=> cancelBtn()}>취소</ModalCancelButton>
        <ModalSubmitButton type={'submit'}>정산 신청</ModalSubmitButton>
      </SettlementFooter>
    </SettlementForm>
  )
}

export default function AccountManage() {
  const navigate = useNavigate()
  const [tokenResultInfo] = useAtom(tokenResultAtom)
  const setModal = useSetAtom(modalController)
  const [adminInfoState, setAdminInfoState] = useAtom(AdminInfo) //매체 전환 계정 정보
  const [accountProfileState, setAccountProfileState] = useAtom(accountProfile) //프로필 조회
  const [revenueState, setRevenueState] = useAtom(accountInfoRevenue) //수익 현황
  const [createInvoice, setCreateInvoice] = useState(accountCreateInvoice) //정산신청
  const [accountInfoTableData, setAccountInfoTableData] = useAtom(accountInfoTable) //월별 정산 이력 테이블 데이터
  const [originAccountInfoTableData, setOriginAccountInfoTableData] = useState([])
  const thisMonth = getThisMonth().startDay.slice(0, 7);

  const getDefaultSearchState = useCallback(() => ({
    searchStartDate: thisMonth,
    searchEndDate: thisMonth,
  }), [thisMonth]);

  const [searchState, setSearchState] = useState(getDefaultSearchState);
  const [downloadTrigger, setDownloadTrigger] = useState(0);
  const [mediaOptions, setMediaOptions] = useState([{value:"",label:"전체",data:null}]);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const monthlyRequestIdRef = useRef(0);

  useEffect(() => {
    if(tokenResultInfo.role === "NORMAL") return
    selKeywordUser("").then(response => {
      const list = Array.isArray(response) ? response : []
      const options = [{value:"",label:"전체",data:null},...list.map(item => ({
        value:item.username,
        label:item.siteName || item.username,
        data:item,
      }))]
      setMediaOptions(options)
      setSelectedMedia(options.find(option => option.value === adminInfoState.convertedUser) || options[0])
    })
  },[adminInfoState.convertedUser,tokenResultInfo.role])

  const normalizeMonth = useCallback((value) => {
    if (!value) {
      return '';
    }

    const stringValue = String(value);

    if (stringValue.includes('-')) {
      return stringValue.substring(0, 7);
    }

    if (stringValue.length >= 6) {
      return `${stringValue.substring(0, 4)}-${stringValue.substring(4, 6)}`;
    }

    return stringValue;
  }, []);

  const filterAccountDataByMonth = useCallback((data, startMonth, endMonth) => {
    return data.filter(row => {
      const rowMonth = row.statisticsMonth || row.month;

      if (!rowMonth) {
        return false;
      }

      const targetMonth = normalizeMonth(rowMonth);

      if (startMonth && targetMonth < startMonth) {
        return false;
      }

      if (endMonth && targetMonth > endMonth) {
        return false;
      }

      return true;
    });
  }, [normalizeMonth]);

  const applyThisMonthData = useCallback((response) => {
    if (response !== null) {
      const filteredData = filterAccountDataByMonth(
          response,
          normalizeMonth(searchState.searchStartDate),
          normalizeMonth(searchState.searchEndDate)
      );

      setOriginAccountInfoTableData(response);
      setAccountInfoTableData(filteredData);
      return;
    }

    setOriginAccountInfoTableData([]);
    setAccountInfoTableData([]);
  }, [
    filterAccountDataByMonth,
    normalizeMonth,
    searchState.searchStartDate,
    searchState.searchEndDate,
    setAccountInfoTableData,
  ]);

  useEffect(() => {
    const startMonth = normalizeMonth(searchState.searchStartDate);
    const endMonth = normalizeMonth(searchState.searchEndDate);

    if (!startMonth && !endMonth) {
      setAccountInfoTableData(originAccountInfoTableData);
      return;
    }

    const filteredData = filterAccountDataByMonth(
        originAccountInfoTableData,
        startMonth,
        endMonth
    );

    setAccountInfoTableData(filteredData);
  }, [
    searchState.searchStartDate,
    searchState.searchEndDate,
    originAccountInfoTableData,
    normalizeMonth,
    filterAccountDataByMonth,
    setAccountInfoTableData,
  ]);
  /**
   * 어드민 정산 수익, 월별 수익 현황 조회
   * @param userName
   */
  const handleAdminApi = useCallback((userName) => {
    const requestId = ++monthlyRequestIdRef.current;
    setOriginAccountInfoTableData([]);
    setAccountInfoTableData([]);

    accountMonthlyListTableData(userName).then(response => {
      if (requestId !== monthlyRequestIdRef.current) return;
      const rows = Array.isArray(response) ? response : [];
      const selectedRows = userName
          ? rows.filter(row => row?.username === userName)
          : rows;
      applyThisMonthData(selectedRows);
    });

    accountRevenueStatus(userName).then(response => {
      if (requestId === monthlyRequestIdRef.current && response !== null) {
        setRevenueState(response);
      }
    });
  }, [
    applyThisMonthData,
    setAccountInfoTableData,
    setRevenueState,
  ]);

  useEffect(() => {
    if (createInvoice.requestAmount > 0 && accountProfileState?.username) {
      accountCreateInvoiceRecord(createInvoice).then(response => {
        if (response) {
          accountRevenueStatus(accountProfileState.username).then(response => {
            if (response !== null) {
              setRevenueState(response);
            }
          });
        }
      });
    }

    return () => {
      setModal({isShow: false});
    };
  }, [
    createInvoice,
    accountProfileState?.username,
    setModal,
    setRevenueState,
  ]);

  useEffect(() => {
    setOriginAccountInfoTableData([]);
    setAccountInfoTableData([]);
  }, [
    adminInfoState.convertedUser,
    getDefaultSearchState,
    setAccountInfoTableData,
  ]);

  const applySelectedMedia = media => {
    if(media) {
      localStorage.setItem("mediaUsername",media.username)
      setAdminInfoState(prev => ({
        ...prev,
        convertedUser:media.username,
        name:media.siteName,
        id:media.id,
      }))
    } else {
      localStorage.removeItem("mediaUsername")
      setAdminInfoState(prev => ({
        ...prev,convertedUser:"",name:"",id:"",accountProfile:false,
      }))
    }
  }

  const handleMediaConditionChange = option => {
    setSelectedMedia(option)
    applySelectedMedia(option?.data)
  }

  const handleResetCondition = () => {
    setSearchState(getDefaultSearchState())
    setSelectedMedia(mediaOptions[0] || null)
    if(tokenResultInfo.role !== "NORMAL") applySelectedMedia(null)
  }

  useEffect(() => {
    if (tokenResultInfo.role !== 'NORMAL') {
      if (adminInfoState.convertedUser !== '') {
        accountUserProfile(adminInfoState.convertedUser).then(response => {
          setAccountProfileState(response);
          handleAdminApi(adminInfoState.convertedUser);
        });
      } else {
        setAccountProfileState(null);
        handleAdminApi('');
      }

      return;
    }

    userAccountProfile(tokenResultInfo.username).then(response => {
      setAccountProfileState(response);

      if (response !== null) {
        const requestId = ++monthlyRequestIdRef.current;
        userAccountRevenueStatus(tokenResultInfo.username).then(response => {
          if (requestId === monthlyRequestIdRef.current) setRevenueState(response);
        });

        userAccountMonthlyListTableData(tokenResultInfo.username).then(response => {
          if (requestId !== monthlyRequestIdRef.current) return;
          const rows = Array.isArray(response) ? response : [];
          applyThisMonthData(rows.filter(row => row?.username === tokenResultInfo.username));
        });
      }
    });
  }, [
    adminInfoState.convertedUser,
    applyThisMonthData,
    handleAdminApi,
    setAccountProfileState,
    setRevenueState,
    tokenResultInfo.role,
    tokenResultInfo.username,
  ]);

  const handleRevenueState = (data) => { //정산 신청 완료
    setCreateInvoice(prev => ({
      ...prev,
      username: accountProfileState.username,
      requesterId: tokenResultInfo.id,
      requestAmount: data,
      invoiceStatus: 'INVOICE_REQUEST',
    }));
    setModal({
      isShow: false
    })
  }
  const handleModalRequestAmount = () => {
    if(accountProfileState !== null && accountProfileState !== undefined) {
    revenueState?.revenueBalance !== 0 ? setModal({
        isShow: true,
        width: 700,
        blur: true,
        modalComponent: () => {return <ModalRequestAmount tax={accountProfileState.taxYn} revenueStatus={revenueState} handleOnSubmit={handleRevenueState} maxAmount={revenueState?.revenueBalance}/>}
      })
      :
      toast.warning('정산 가능 금액이 없습니다.')
    } else {
      toast.warning('정산 프로필을 먼저 등록해주세요.')
    }
  }
  return (
    <AccountPage>
      <CompactFilterPanel>
          <FilterPanelTitle>
            <strong>정산 정보</strong>
            <span>매체사와 월별 정산 내역을 확인합니다.</span>
          </FilterPanelTitle>
          {tokenResultInfo.role !== "NORMAL" && <ConditionField $selected={Boolean(selectedMedia?.value)}>
            <FilterIcon aria-hidden="true"><svg viewBox="0 0 24 24"><circle cx="12" cy="7" r="3.5"/><path d="M5.5 20v-2.5a6.5 6.5 0 0 1 13 0V20"/></svg></FilterIcon>
            <label>매체사</label>
            <Select styles={accountSelectStyle} options={mediaOptions}
              value={selectedMedia || mediaOptions[0]} onChange={handleMediaConditionChange}
              isSearchable placeholder="매체사를 선택해주세요."/>
          </ConditionField>}
          <ConditionField $date>
            <FilterIcon aria-hidden="true"><svg viewBox="0 0 24 24"><rect x="4" y="5.5" width="16" height="14" rx="2"/><path d="M8 3v5M16 3v5M4 10h16"/></svg></FilterIcon>
            <label>조회 기간</label>
            <MonthRangePicker value={searchState} setValue={setSearchState}/>
          </ConditionField>
          <ConditionActions>
            <ResetConditionButton type="button" onClick={handleResetCondition}>
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 4v6h6M20 20v-6h-6M5.5 15a7 7 0 0 0 12 2M18.5 9a7 7 0 0 0-12-2"/></svg>
              초기화
            </ResetConditionButton>
          </ConditionActions>
      </CompactFilterPanel>
      <OverviewGrid>
        <AccountCard $featured>
          <CardHeader>
            <CardHeading><Accent/><div><strong>수익 현황</strong><span>현재 수익금과 정산 진행 상태를 확인합니다.</span></div></CardHeading>
            {(adminInfoState.convertedUser !== '' && accountProfileState !== null) &&
              <PrimaryButton type="button" onClick={handleModalRequestAmount}>정산 신청</PrimaryButton>}
          </CardHeader>
          <RevenueHero>
            <RevenueMain>
              <RevenueIcon>₩</RevenueIcon>
              <div><span>누적 수익금</span><strong>{decimalFormat(revenueState.revenueAmount)}<em>원</em></strong></div>
            </RevenueMain>
            <BalanceBox><span>정산 가능 금액</span><strong>{decimalFormat(revenueState.revenueBalance)}<em>원</em></strong></BalanceBox>
          </RevenueHero>
          <RevenueMetrics>
            <RevenueMetric $tone="blue"><i/><span>정산 신청</span><strong>{decimalFormat(revenueState.invoiceRequestAmount)}<em>원</em></strong></RevenueMetric>
            <RevenueMetric $tone="gray"><i/><span>총 이월</span><strong>{decimalFormat(revenueState.totalCarryOver)}<em>원</em></strong></RevenueMetric>
            <RevenueMetric $tone="orange"><i/><span>지급 예정</span><strong>{decimalFormat(revenueState.examinedCompletedAmount)}<em>원</em></strong></RevenueMetric>
            <RevenueMetric $tone="green"><i/><span>지급 완료</span><strong>{decimalFormat(revenueState.paymentCompletedAmount)}<em>원</em></strong></RevenueMetric>
          </RevenueMetrics>
        </AccountCard>

        <AccountCard>
          <CardHeader>
            <CardHeading><Accent/><div><strong>정산 프로필</strong><span>정산에 사용되는 사업자와 지급 계좌 정보입니다.</span></div></CardHeading>
            {/*{accountProfileState && <StatusBadge>등록 완료</StatusBadge>}*/}
          </CardHeader>
          {accountProfileState ? <ProfileGrid>
            <ProfileItem><ProfileIcon>사업자</ProfileIcon><div><strong>{accountProfileState.businessName || "-"}</strong><small>{accountProfileState.businessNumber || "-"}</small></div></ProfileItem>
            <ProfileItem><ProfileIcon>담당자</ProfileIcon><div><strong>{accountProfileState.managerName || "-"}</strong><small>{accountProfileState.managerPhone || "-"} · {accountProfileState.managerEmail || "-"}</small></div></ProfileItem>
            <ProfileItem><ProfileIcon>계좌</ProfileIcon><div><strong>{accountProfileState.bankAccountNumber || "-"}</strong><small>{refundRequestData.bankType.find(type => type.value === accountProfileState.bankType)?.label || "-"} · 예금주 {accountProfileState.accountHolder || "-"}</small></div></ProfileItem>
          </ProfileGrid> : <EmptyProfile>
            <EmptyIcon>₩</EmptyIcon>
            <strong>정산 프로필이 등록되지 않았습니다.</strong>
            <span>{tokenResultInfo.role !== 'NORMAL' && adminInfoState.convertedUser === '' ? "매체 계정으로 전환해 정산 정보를 확인해주세요." : "정산을 진행하려면 프로필 정보가 필요합니다."}</span>
            {tokenResultInfo.role !== 'NORMAL' && adminInfoState.convertedUser !== '' &&
              <SecondaryButton type="button" onClick={()=>navigate('/board/accountProfile')}>정산 프로필 등록</SecondaryButton>}
          </EmptyProfile>}
        </AccountCard>
      </OverviewGrid>

      <AccountCard>
        <CardHeader>
          <CardHeading><Accent/><div><strong>월별 정산 이력</strong><span>기간별 수익과 지급 완료 내역을 확인합니다.</span></div></CardHeading>
          <ExcelButton type="button" onClick={()=>setDownloadTrigger(value=>value+1)}>엑셀 저장</ExcelButton>
        </CardHeader>
        <AccountTable>
          <HorizontalScrollGuide/>
          <BoardSearchResult>
            <Table columns={accountInfoColumns}
                 lockedRows={lockedRows}
                 summaryReducer={summaryReducer}
                 data={accountInfoTableData}
                 defaultSortInfo={[{name:"username", dir: 1}, {name:"statisticsMonth", dir: -1}]}
                 titleTotal={false}
                 settings={accountInfoSetting}
                 showHoverRows={false}
                 downloadList={false}
                 downloadTrigger={downloadTrigger}
                 fileName="월별_정산_이력"
                 activeCell={[0]}
                 headerHeight={44}
                 style={{minHeight:420}}
                 emptyText={
                   <EmptyProfile>
                     <EmptyIcon>
                       <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                         <rect x="4" y="3" width="16" height="18" rx="2"/>
                         <path d="M8 8h8M8 12h8M8 16h5"/>
                       </svg>
                     </EmptyIcon>
                     <strong>정산 이력이 없습니다.</strong>
                     <span>선택한 기간에 조회된 정산 내역이 없습니다.</span>
                   </EmptyProfile>
                 }
            />
          </BoardSearchResult>
        </AccountTable>
      </AccountCard>
      <ToastContainer position="top-center"
                      autoClose={1500}
                      hideProgressBar
                      newestOnTop={false}
                      closeOnClick
                      rtl={false}
                      pauseOnFocusLoss
                      draggable
                      pauseOnHover
                      limit={1}
                      style={{zIndex: 9999999}}/>
    </AccountPage>
  )
}

const AccountPage=styled.div`
  display:flex;width:100%;flex-direction:column;gap:16px;
`;
const SettlementForm=styled.form`width:100%;`;
const SettlementModalBody=styled.div`display:flex;flex-direction:column;gap:14px;`;
const SettlementNotice=styled.div`
  display:flex;align-items:flex-start;gap:11px;padding:13px 14px;border:1px solid #d7e5f5;border-radius:9px;background:#f6faff;
  strong{display:block;margin-bottom:5px;color:#36506d;font-size: var(--font-size-11);}p{margin:2px 0;color:#718196;font-size: var(--font-size-9);line-height:1.55;}
`;
const NoticeIcon=styled.i`
  display:flex;width:26px;height:26px;flex:0 0 26px;align-items:center;justify-content:center;
  border-radius:7px;background:var(--color-primary-muted);color:var(--color-primary-strong);font-size: var(--font-size-11);font-style:normal;font-weight:800;
`;
const AvailableAmount=styled.div`
  display:flex;min-height:78px;align-items:center;justify-content:space-between;padding:15px 17px;
  border-radius:10px;background:linear-gradient(135deg,var(--color-main),var(--color-primary-strong));color:var(--color-surface);
  span{color:var(--color-primary-muted);font-size: var(--font-size-10);}strong{font-size: var(--font-size-21);}em{margin-left:5px;color:var(--color-primary-border);font-size: var(--font-size-9);font-style:normal;}
`;
const AmountSection=styled.div`padding:15px 16px;border:1px solid #e1e7ed;border-radius:9px;background:var(--color-surface);`;
const AmountLabel=styled.div`
  strong,span{display:block;}strong{color:#3a4654;font-size: var(--font-size-11);}span{margin-top:4px;color:#919aa4;font-size: var(--font-size-9);}
`;
const AmountInputRow=styled.div`display:flex;align-items:center;gap:8px;margin-top:12px;`;
const AmountInputWrap=styled.div`
  display:flex;height:42px;flex:1;align-items:center;border:1px solid #cfd8e3;border-radius:7px;background:var(--color-surface);
  &:focus-within{border-color:var(--color-primary);box-shadow:0 0 0 3px rgba(59,130,246,.1);}
  input{width:100%;height:100%;padding:0 12px;border:0;outline:0;background:transparent;color:#273444;font-size: var(--font-size-14);font-weight:750;text-align:right;}
  span{padding-right:12px;color:#7f8a96;font-size: var(--font-size-10);}
`;
const AllAmountButton=styled.button`
  height:42px;padding:0 13px;border:1px solid #bfd2e8;border-radius:7px;background:#f4f8fd;color:#356da8;
  font-size: var(--font-size-10);font-weight:700;cursor:pointer;&:hover{background:#eaf3fd;}
`;
const AmountError=styled.span`display:block;margin-top:7px;color:var(--color-danger);font-size: var(--font-size-9);text-align:right;`;
const PaymentSummary=styled.div`padding:14px 16px;border:1px solid #e1e7ed;border-radius:9px;background:#f8fafc;`;
const SummaryRow=styled.div`
  display:flex;align-items:center;justify-content:space-between;padding:5px 0;
  span{color:${({$total})=>$total?"#334155":"#7a8693"};font-size:${({$total})=>$total?"var(--font-size-11)":"var(--font-size-9)"};font-weight:${({$total})=>$total?700:500};}
  strong{color:${({$total})=>$total?"var(--color-primary-strong)":"#475569"};font-size:${({$total})=>$total?"var(--font-size-15)":"var(--font-size-10)"};}
`;
const SummaryDivider=styled.div`height:1px;margin:8px 0;background:var(--color-border-strong);`;
const SettlementFooter=styled.footer`
  display:flex;align-items:center;justify-content:center;gap:8px;padding:0 25px 20px;
`;
const ModalCancelButton=styled.button`
  min-width:104px;height:40px;border:1px solid #d5dde6;border-radius:7px;background:var(--color-surface);color:#5f6c79;font-size: var(--font-size-10);font-weight:700;cursor:pointer;
`;
const ModalSubmitButton=styled(ModalCancelButton)`border-color:var(--color-primary-strong);background:var(--color-primary-strong);color:var(--color-surface);&:hover{background:var(--color-primary-dark);}`;
const OverviewGrid=styled.div`
  display:grid;grid-template-columns:minmax(0,1.15fr) minmax(0,.85fr);gap:16px;
  @media(max-width:1050px){grid-template-columns:1fr;}
`;
const AccountCard=styled.section`
  overflow:hidden;border:1px solid ${({$featured})=>$featured?"#cfe0f4":"#e1e6eb"};
  border-radius:10px;background:var(--color-surface);box-shadow:0 5px 18px rgba(31,41,55,.045);
`;
const CardHeader=styled.div`
  display:flex;min-height:68px;align-items:center;justify-content:space-between;gap:14px;
  padding:12px 16px;border-bottom:1px solid #e9edf1;background:#fbfcfe;
`;
const CardHeading=styled.div`
  display:flex;min-width:0;align-items:center;gap:10px;
  strong,span{display:block;}strong{color:var(--color-text-strong);font-size: var(--font-size-16);font-weight:750;}
  span{margin-top:4px;color:var(--color-text-muted);font-size: var(--font-size-12);}
`;
const Accent=styled.i`width:3px;height:32px;flex:0 0 3px;border-radius:3px;background:var(--color-primary);`;
const CompactFilterPanel=styled.section`
  display:flex;min-height:54px;align-items:center;justify-content:flex-end;width:100%;gap:8px;
  border-radius:10px;background:#f4f6f8;
  @media(max-width:900px){align-items:flex-end;flex-wrap:wrap;}
  @media(max-width:640px){align-items:stretch;justify-content:flex-start;flex-direction:column;gap:10px;}
`;
const FilterPanelTitle=styled.div`
  min-width:180px;margin-right:auto;padding:0 6px;
  strong,span{display:block;}strong{color:var(--color-text-strong);font-size: var(--font-size-16);font-weight:750;}
  span{margin-top:5px;color:var(--color-text-muted);font-size: var(--font-size-12);}
  @media(max-width:900px){width:100%;margin-bottom:2px;}
`;
const ConditionField=styled.div`
  display:flex;height:48px;min-width:${({$date})=>$date?"285px":"230px"};align-items:center;gap:8px;
  padding:0 10px;border:1px solid ${({$selected})=>$selected?"#7fb1e5":"#dce2e8"};border-radius:7px;background:${({$selected})=>$selected?"#f3f8ff":"var(--color-surface)"};
  box-shadow:${({$selected})=>$selected?"inset 3px 0 0 var(--color-primary-strong),0 3px 9px rgba(37,99,235,.1)":"0 2px 5px rgba(31,41,55,.04)"};
  label{flex:0 0 auto;color:#34404d;font-size: var(--font-size-13);font-weight:750;white-space:nowrap;}
  > span:first-child{color:${({$selected})=>$selected?"#1d5fae":"var(--color-primary)"};}
  @media(max-width:640px){width:100%;min-width:0;}
`;
const FilterIcon=styled.span`
  display:inline-flex;flex:0 0 auto;color:var(--color-primary);
  svg{width:17px;height:17px;fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.7;}
`;
const MonthPickerRow=styled.div`
  display:grid;width:170px;grid-template-columns:minmax(0,1fr) 12px minmax(0,1fr);align-items:center;gap:1px;
  @media(max-width:640px){width:100%;}
`;
const MonthPickerBox=styled.div`
  position:relative;min-width:0;
  .react-datepicker-wrapper,.react-datepicker__input-container{display:block;width:100%;}
  input{width:100%;height:46px;padding:0 3px;border:0;background:transparent;box-shadow:none;
    color:var(--color-text);font-size: var(--font-size-13);font-weight:600;text-align:center;outline:0;}
  input:hover,input:focus{border:0;box-shadow:none;}
`;
const MonthRangeSeparator=styled.span`color:#8b96a2;font-size: var(--font-size-13);text-align:center;`;
const ConditionActions=styled.div`display:flex;align-items:center;justify-content:flex-end;gap:7px;`;
const ResetConditionButton=styled.button`
  display:inline-flex;min-width:76px;height:48px;align-items:center;justify-content:center;padding:0 13px;
  border:1px solid #dfe3e7;border-radius:8px;background:var(--color-surface);box-shadow:0 2px 5px rgba(31,41,55,.04);
  gap:5px;color:#68717c;font-size: var(--font-size-13);font-weight:650;cursor:pointer;
  svg{width:14px;height:14px;fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.8;}
  &:hover{border-color:var(--color-primary-border);background:var(--color-primary-soft);color:var(--color-primary-strong);}
`;
const PrimaryButton=styled.button`
  display:inline-flex;height:34px;align-items:center;justify-content:center;padding:0 14px;
  border:1px solid var(--color-primary-strong);border-radius:7px;background:var(--color-primary-strong);color:var(--color-surface);font-size: var(--font-size-10);font-weight:750;cursor:pointer;
  &:hover{background:var(--color-primary-dark);}
`;
const SecondaryButton=styled(PrimaryButton)`margin-top:12px;border-color:#b9d0eb;background:var(--color-surface);color:var(--color-primary-strong);&:hover{background:var(--color-primary-soft);}`;
const RevenueHero=styled.div`
  display:grid;grid-template-columns:minmax(0,1fr) minmax(180px,.48fr);gap:12px;padding:18px 18px 14px;
  @media(max-width:620px){grid-template-columns:1fr;}
`;
const RevenueMain=styled.div`
  display:flex;min-height:88px;align-items:center;gap:14px;padding:15px 17px;border-radius:10px;
  background:linear-gradient(135deg,var(--color-main) 0%,var(--color-primary-strong) 100%);color:var(--color-surface);
  span{display:block;margin-bottom:7px;color:var(--color-primary-muted);font-size: var(--font-size-13);}strong{font-size: var(--font-size-24);letter-spacing:-.03em;}
  em{margin-left:5px;color:var(--color-primary-border);font-size: var(--font-size-13);font-style:normal;}
`;
const RevenueIcon=styled.i`
  display:flex;width:44px;height:44px;flex:0 0 44px;align-items:center;justify-content:center;
  border:1px solid rgba(255,255,255,.25);border-radius:10px;background:rgba(255,255,255,.12);font-size: var(--font-size-20);font-style:normal;font-weight:800;
`;
const BalanceBox=styled.div`
  display:flex;min-height:88px;flex-direction:column;justify-content:center;padding:15px 17px;
  border:1px solid var(--color-primary-border);border-radius:10px;background:var(--color-primary-soft);
  span{margin-bottom:8px;color:#64809f;font-size: var(--font-size-13);}strong{color:var(--color-main);font-size: var(--font-size-19);}em{margin-left:4px;color:#64809f;font-size: var(--font-size-9);font-style:normal;}
`;
const RevenueMetrics=styled.div`
  display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:8px;padding:0 18px 18px;
  @media(max-width:700px){grid-template-columns:repeat(2,1fr);}
`;
const metricTone={blue:"var(--color-primary)",gray:"#94a3b8",orange:"#f59e0b",green:"#10b981"};
const RevenueMetric=styled.div`
  position:relative;min-width:0;padding:12px 12px 11px;border:1px solid #e4e9ef;border-radius:8px;background:var(--color-surface);
  >i{position:absolute;top:0;left:0;width:100%;height:3px;background:${({$tone})=>metricTone[$tone]};}
  span{display:block;margin-bottom:7px;color:#7b8794;font-size: var(--font-size-12);}strong{display:block;overflow:hidden;color:#364252;font-size: var(--font-size-12);text-overflow:ellipsis;white-space:nowrap;}
  em{margin-left:3px;color:#8d97a2;font-size: var(--font-size-11);font-style:normal;}
`;
const StatusBadge=styled.span`
  display:inline-flex;height:27px;align-items:center;padding:0 9px;border:1px solid #bfe7d5;
  border-radius:999px;background:#effaf5;color:#16845d;font-size: var(--font-size-9);font-weight:700;
`;
const ProfileGrid=styled.div`display:flex;flex-direction:column;padding:7px 16px 14px;`;
const ProfileItem=styled.div`
  display:flex;min-width:0;align-items:center;gap:12px;padding:13px 3px;border-bottom:1px solid #edf1f4;
  &:last-child{border-bottom:0;}div{min-width:0;}span,strong,small{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
  span{margin-bottom:4px;color:var(--color-text-muted);font-size: var(--font-size-13);}strong{color:#344150;font-size: var(--font-size-13);}small{margin-top:4px;color:#697685;font-size: var(--font-size-11);}
`;
const ProfileIcon=styled.i`
  display:flex;width:38px;height:38px;flex:0 0 38px;align-items:center;justify-content:center;
  border-radius:9px;background:var(--color-primary-soft);color:var(--color-primary-strong);font-size: var(--font-size-11);font-style:normal;font-weight:800;
`;
const EmptyProfile=styled.div`
  display:flex;min-height:222px;align-items:center;justify-content:center;flex-direction:column;padding:24px;text-align:center;
  strong{margin-top:10px;color:#4a5663;font-size: var(--font-size-12);}span{margin-top:6px;color:#929ba5;font-size: var(--font-size-10);}
`;
const EmptyIcon=styled.i`display:flex;width:46px;height:46px;align-items:center;justify-content:center;border-radius:50%;background:#f0f4f8;color:#8ea0b2;font-size: var(--font-size-18);font-style:normal;`;
const ExcelButton=styled.button`
  display:inline-flex;min-width:88px;height:34px;align-items:center;justify-content:center;padding:0 12px;
  border:1px solid #d7e5d9;border-radius:6px;background:#f7fbf7;color:#47774d;font-size: var(--font-size-10);font-weight:700;cursor:pointer;
  &:hover{border-color:#bcd6c0;background:#eef7ef;}
`;
const AccountTable=styled.div`
  padding:4px 12px 14px;
  ${BoardSearchResult}{margin:0;padding:0;background:var(--color-surface);}
  .InovuaReactDataGrid--theme-default-light{overflow:hidden;border:1px solid var(--color-border-strong);border-radius:8px;font-size: var(--font-size-11);}
  .InovuaReactDataGrid__header,.InovuaReactDataGrid__column-header{border-color:#cddff5 !important;background:#f2f7fd;}
  .InovuaReactDataGrid__header{border-bottom:2px solid #8bb8ea !important;}
`;
